module.exports = __webpack_public_path__ + "img/9904.a6fc85e1.jpg";